import React,{useEffect,useState,useContext} from 'react';
import ReactTooltip from 'react-tooltip';
import { ListGroup, Container, Row, Col, Modal, Button, Nav } from 'react-bootstrap';
import { Link } from "react-router-dom";

import { apiUrl, myHeaders_Auth_With_Cache_Control } from "Api/Api";
//import { HubspotForm } from "Api/HubspotApi.js";

import axios from "axios";

import { local_routes } from 'utils/Routes';

//import Select from 'react-select';

import UserContext from 'store/UserContext';

//import { slugify } from 'utils/Helper';

//import { useForm } from 'react-hubspot'

import { assembleNickname, get_current_unix_stamp } from "utils/Helper.js";

//import { makeCall } from "components/VideoChat/VideoChatControl";

import './style.css';

function FollowControlModal (props) {
  //console.log("OnboardingModal constructor",props);
  
  const user_context = useContext(UserContext);

  const [tab_choice, setTabChoice] = useState('categories'); // or register

  //const [step_name, setStepName] = useState('');
  const [loading, setLoading] = useState(false);
  const [followed_entities, setFollowedEntities] = useState([]);
  
  const [message, setMessage] = useState(<React.Fragment></React.Fragment>);

  const tab_info = {
    categories: {
      title: "Categories",
    },
    locations: {
      title: "Cities",
    },
    events: {
      title: "Events",
    },
    presentations: {
      title: "Presentations",
    },
    users: {
      title: "Users",
    }
  }

  async function onUnFollow (selected_entity) {
    console.log("onUnFollow",selected_entity);
    
    // first remove from state
    let tmp_followed_entities = followed_entities.filter( element => element.entity_uuid !== selected_entity.entity_uuid );
    setFollowedEntities(tmp_followed_entities);
    
    let patch_obj = {
      [tab_choice+'.audience']: [
        {
          entity_uuid: selected_entity.entity_uuid,
          xref_data: {
            favorited_time: -1
          }
        }
      ]
    };
    
    await axios.patch(`${apiUrl}users/${user_context.user_info.entity_uuid}`,patch_obj);
    
  }

  async function setupEntities (tmp_tab_choice = tab_choice) {
    
    setMessage(<span style={{ color: 'darkgray', fontSize: 'smaller' }}> Working...</span>);

    let followed_entities_response = await axios.get(`${apiUrl}users/${user_context.user_info.entity_uuid}/${tmp_tab_choice}.audience?filter_obj=${encodeURIComponent('{"favorited_time":{"gte":1}}')}`,myHeaders_Auth_With_Cache_Control);

    if (tmp_tab_choice === 'users') {
      followed_entities_response.data.forEach( element => {
        element.entity_name = assembleNickname(element);
        if (element.xref_data) {
          if (element.xref_data.friended_time) {
            element.friend_flag = true;
            if (element.last_active_time > get_current_unix_stamp() - 120) {
              element.friend_online_flag = true;
            }
          }
        }
        
      });
    }
    let tmp_followed_entities = followed_entities_response.data.sort((a,b) => a.entity_name.localeCompare(b.entity_name));

    console.log("tmp_followed_entities",tmp_followed_entities);
    setFollowedEntities(tmp_followed_entities);

    setMessage(<span>&nbsp;</span>);
    setLoading(false);
  }

  function changeTab (eventKey) {
    console.log("changeTab",eventKey,tab_choice);
    if (eventKey !== tab_choice) {
      setFollowedEntities([]);
      setMessage(<span>&nbsp;</span>);
      setTabChoice(eventKey);
      setupEntities(eventKey);
    }
    
  }

  // on mount
  useEffect(() => {
    console.log("FollowControlModal useEffect props.show");

    if (!user_context.user_info || !user_context.user_info.entity_uuid) {
      return;
    }
    
    setupEntities();
    
  }, [props.show]);
  
  async function onCall (user_info) {
    let screen_width = window.screen.width * 0.8;
    let screen_height = window.screen.height * 0.8;
    let screen_left = window.screen.width * 0.1;
    let newWindow = window.open('about:blank', 'PechaKucha Chat '+new Date(), 'left='+screen_left+',height='+screen_height+',width='+screen_width+',toolbar=0,location=0,menubar=0');
    
    
    
    //await makeCall(user_info);
    // close modal first!
    props.onHide();
    
    // first make new PK "chat"
    let post_obj = {
      entity_name: user_context.user_info.nickname+' - '+user_info.entity_name,
      friendly_url: user_context.user_info.nickname+'-'+user_info.entity_name,
      public_status: 'super_private'
    }
    let new_chat_response = await axios.post(`${apiUrl}chats`,post_obj);
    
    // need the friendly_url if it was dynamically added
    //let get_chat_response = await axios.get(`${apiUrl}chats/${new_chat_response.data.entity_uuid}`);
    
    let chat_uuid = new_chat_response.data.entity_uuid;
    let chat_token = new_chat_response.data.openvidu_token;
    let chat_session_id = new_chat_response.data.openvidu_session_id;
    let chat_friendly_url = new_chat_response.data.friendly_url;

    // now invite somebody to chat
    post_obj = {
      invited_time: get_current_unix_stamp(),
      entity_reader_integer: 1  
    }
    let invite_chat_response = await axios.post(`${apiUrl}chats/${chat_uuid}/users/${user_info.entity_uuid}`,post_obj);

    newWindow.location = '/chats/'+chat_friendly_url;

    /*
    // open new tab for the actual chat
    let screen_width = window.screen.width * 0.8;
    let screen_height = window.screen.height * 0.8;
    let screen_left = window.screen.width * 0.1;
    window.open('/chats/'+chat_friendly_url, 'PechaKucha Chat '+new Date(), 'left='+screen_left+',height='+screen_height+',width='+screen_width+',toolbar=0,location=0,menubar=0');
    */
  }
  
  return (
    <Modal
      style={{ color: 'black' }}
      show={props.show}
      onHide={props.onHide}
      //{...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable={true}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Manage What I Follow<br/>
          <span style={{ fontSize: "70%", color: "darkgray" }}>Click 'Unfollow' to stop notifications</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container style={{ height: "400px" }}>
          <Row style={{ paddingBottom: "10px" }}>
            <Col>
              <Nav justify variant="tabs" activeKey={tab_choice} onSelect={(k) => changeTab(k)}>
                {
                  Object.keys(tab_info).map( tab_name => {
                    return (
                      <Nav.Item key={tab_name}>
                        <Nav.Link eventKey={tab_name}>{tab_info[tab_name].title}</Nav.Link>
                      </Nav.Item>
                    );
                  })
                }
              </Nav>
            </Col>
          </Row>
          <Row>
            <Col>
              <ListGroup variant="flush">
                {
                  followed_entities.map( element => {
                    return (
                      <ListGroup.Item key={element.entity_uuid}>
                        { element.friend_flag &&
                          <span data-tip="Mutual friends"><i className="fa fa-handshake-o" aria-hidden="true"></i>&nbsp;</span>
                        }
                        { (element.friendly_url && element.status_code === 1) ?
                          <Link target="_blank" to={local_routes[tab_choice]+'/'+element.friendly_url}>{element.entity_name}</Link>
                          :
                          <span>{element.entity_name}</span>
                        }
                        <span className="float-right">
                          { element.friend_online_flag &&
                            <Button variant="success" data-tip="Start a Video Call" style={{ marginRight: "5px" }} onClick={() => onCall(element)}>Call</Button>
                          }
                          <Button variant="pkprimary" onClick={() => onUnFollow(element)}>Unfollow</Button>
                        </span>
                        <ReactTooltip />
                      </ListGroup.Item>
                    );
                  })
                }
              </ListGroup>
            </Col>
          </Row>
          
        </Container>
      </Modal.Body>
      {/*
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>Done</Button>
      </Modal.Footer>
      */}
    </Modal>
  );
}

function FollowControlModalButton (props) {
  const [modalShow, setModalShow] = React.useState(false);

  console.log("FollowControlModalButton",props);

  let button_icon = '';
  let button_text = 'Manage What I Follow';
  //if (props.event_entity_name) {
  //  button_text = props.event_entity_name;
  //}
  let button_tooltip = 'Click to see more options';

  return (
    <React.Fragment>
      <Button variant="pkprimary" onClick={() => setModalShow(true)}>
        {button_icon}{button_text}
      </Button>

      <FollowControlModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      <ReactTooltip />
    </React.Fragment>
  );
}

export default FollowControlModalButton;